// action - state management
import { LOGIN, LOGOUT, REGISTER } from './actions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
};

// -----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            return {
                ...state,
                user,
            };
        }
        case LOGIN: {
            const { user, token } = action.payload;
            localStorage.setItem('token', token);
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                token,
                user,
            };
        }
        case LOGOUT: {
            localStorage.removeItem('token');
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                token: '',
                user: null,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
